var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebsite = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icons/website",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.69231 2.25C2.44803 2.25 2.25 2.44803 2.25 2.69231V4.32692H17.4423V2.69231C17.4423 2.44803 17.2443 2.25 17 2.25H2.69231ZM18.9423 2.69231C18.9423 1.6196 18.0727 0.75 17 0.75H2.69231C1.6196 0.75 0.75 1.6196 0.75 2.69231V15.8077C0.75 16.8804 1.6196 17.75 2.69231 17.75H17C18.0727 17.75 18.9423 16.8804 18.9423 15.8077V2.69231ZM17.4423 5.82692H8.21154V10.2885H17.4423V5.82692ZM17.4423 11.7885H8.21154V16.25H17C17.2443 16.25 17.4423 16.052 17.4423 15.8077V11.7885ZM6.71154 16.25V5.82692H2.25V15.8077C2.25 16.052 2.44803 16.25 2.69231 16.25H6.71154Z",
  fill: "#00615C"
}))));
export { SvgWebsite as ReactComponent };
export default __webpack_public_path__ + "images/website.svg";